import { ProAdvert } from 'components/generic'
import { Navigate, Route } from 'react-router-dom'
import Root from 'Root'
import { GroupsPlaceholderHome } from 'screens/Groups'
import { EMARPaywall } from 'screens/Residents/screens/ResidentEmarScreens/components'
import { groupReportsRoutes } from './groupReports'
import { homesRoutes } from './homes'
import { onBoardingRoutes } from './onboarding'
import { organizationRoutes } from './organisation'
import { reportsRoutes } from './reports'
import { residentsRoutes } from './residents'
import { settingsRoutes } from './settings'
import LogsDashboard from 'screens/Logs/LogsDashboardScreen'
import LogScreen from 'screens/Logs/LogScreen'
import todosRoutes from './todos'
import Home from 'screens/Home/Home'
import { HelpCentreScreen } from 'screens/HelpCentre'
import noticeboardRoutes from './noticeboard'
import IncidentLogEditScreen from 'screens/Logs/LogScreen/components/IncidentLogScreens/IncidentLogEditScreen'
import IncidentReportCreateCaseScreen from 'screens/Logs/LogScreen/components/IncidentLogScreens/IncidentReportCreateCaseScreen'
import IncidentReportEditCaseScreen from 'screens/Logs/LogScreen/components/IncidentLogScreens/IncidentReportEditCaseScreen'
import { ForceMFAScreen } from 'screens/MFA/ForceMFAScreen'
import rotaRoutes from './rota'
// import { Suspense } from 'react'

type Role = 'senior-carer' | 'group-manager' | 'group-admin' | 'carehome-admin'

const HomeRoute = (role: Role | null = 'carehome-admin') => {
  switch (role) {
    case 'senior-carer':
      return <Route index element={<Home />} />
    case 'group-manager':
      return <Route index element={<GroupsPlaceholderHome />} />
    case 'group-admin':
      return <Route index element={<GroupsPlaceholderHome />} />
    case 'carehome-admin':
      return <Route index element={<Home />} />
    default:
      return null
  }
}

export const getRoutes = (
  role: Role | null = 'carehome-admin',
  initResponse: any,
  carePlansListScreenV2Enabled: boolean,
  communicationRecordsEnabled: boolean,
  proceduresEnabled: boolean = false
) => (
  <Route path="/" element={<Root initResponse={initResponse} />}>
    {HomeRoute(role)}
    {onBoardingRoutes}
    {residentsRoutes(
      carePlansListScreenV2Enabled,
      communicationRecordsEnabled,
      proceduresEnabled
    )}
    {organizationRoutes}
    <Route path="logs" element={<LogsDashboard />} />
    <Route path="mfa" element={<ForceMFAScreen />} />
    <Route path="logs/:id" element={<LogScreen />} />
    <Route path="logs/:id/edit" element={<IncidentLogEditScreen />} />
    <Route
      path="logs/:id/create-case"
      element={<IncidentReportCreateCaseScreen />}
    />
    <Route
      path="logs/:id/edit-case"
      element={<IncidentReportEditCaseScreen />}
    />
    {noticeboardRoutes}
    {todosRoutes}
    {rotaRoutes}
    {homesRoutes}
    {groupReportsRoutes}
    {reportsRoutes}
    <Route path="pro-advert" element={<ProAdvert />} />
    <Route path="emar-activation" element={<EMARPaywall />} />
    <Route path="help" element={<HelpCentreScreen />} />
    {settingsRoutes}
    <Route path="*" element={<Navigate to="/" />} />
  </Route>
)
